import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import Loader from '../../../components/common/loader/Loader'
import UserAvatar from '../../../components/common/user/user-avatar/UserAvatar'
import { AnalyticsHeader } from '../AnalyticsHeader'

import CertificationEnrolmentProgressDetail from './components/certification-enrolment-progress-detail/CertificationEnrolmentProgressDetail'
import CertificationEnrolmentOverviewTable from './CertificationEnrolmentOverviewTable'

import { useCertificationEnrolmentDetailQuery } from './CertificationEnrolmentAnalytics.codegen'
import { CertificationEnrolmentStatusEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'
import { StatusArchivedGrey } from 'front-end/src/components/common/status/Status'

const CertificationEnrolmentAnalytics: FC<{}> = () => {
  const history = useHistory()
  const { certificationId, enrolmentId } = useParams<{
    certificationId: string
    enrolmentId: string
  }>()
  const { data, loading } = useCertificationEnrolmentDetailQuery({
    variables: {
      certificationId: +certificationId,
      enrolmentId: +enrolmentId
    }
  })

  if (loading) {
    return <Loader />
  }

  const certification = data?.certification
  const enrolment = certification?.enrolment
  const user = enrolment?.user

  if (!user || !enrolment || !certification) {
    return null
  }

  return (
    <div className="CertificationEnrolmentAnalyticsPage">
      <AnalyticsHeader
        goBack={history.goBack}
        showFilterPanel={false}
        className="AnalyticsHeader--detail"
      >
        <>
          <div className="AnalyticsHeader--detail__content">
            <UserAvatar size="normal" user={user} />
            <div className="AnalyticsHeader__title__text">
              <small>
                {user.display_name}{' '}
                <span className="AnalyticsHeader__title__text__subtitle">
                  {enrolment?.status && renderHeaderStatus(enrolment.status)}
                </span>{' '}
              </small>
              <div>
                {certification.name}
                {certification.deleted_at && <StatusArchivedGrey mx="8px" />}
              </div>
            </div>
          </div>
          <div className="AnalyticsHeader--detail__status">
            <CertificationEnrolmentProgressDetail enrolment={enrolment} />
          </div>
        </>
      </AnalyticsHeader>

      <CertificationEnrolmentOverviewTable
        certificationId={certification.id}
        certEnrolmentId={enrolment.id}
        userId={user.id}
      />
    </div>
  )
}

const renderHeaderStatus = (status: CertificationEnrolmentStatusEnum) => {
  switch (status) {
    case CertificationEnrolmentStatusEnum.COMPLETED:
      return <Trans>completed</Trans>
    case CertificationEnrolmentStatusEnum.IN_PROGRESS:
      return <Trans>completing</Trans>
    case CertificationEnrolmentStatusEnum.NOT_STARTED:
      return <Trans>has not started</Trans>
    case CertificationEnrolmentStatusEnum.OVERDUE:
      return <Trans>did not complete in target time</Trans>
  }
}

export default CertificationEnrolmentAnalytics
